import React, {useState} from "react";
import SignInForm from "../components/auth/SignInForm";

function SignIn(){
    return (
        <SignInForm />
    );
};

export default SignIn;